import React from "react";

const BotaoVoltar = () => (
    <div className="botao voltar">
        <a href="javascript:window.history.go(-1)" className="i_12" title="Voltar"></a>
    </div>
);

export default BotaoVoltar;